import theme from '~/design'

export type AlertLevel =
  | 'notification'
  | 'outbreak'
  | 'urgent'
  | 'emergent'
  | 'above'
  | 'below'
  | 'informative'
  | 'rise'
  | 'drop'
  | null

export const alertLabels = {
  notification: 'Notificação',
  outbreak: 'Anomalia',
  urgent: 'Crescimento Abrupto',
  emergent: 'Aumento',
  above: 'Acima',
  rise: 'Emergente',
  drop: 'Declínio',
  below: 'Abaixo',
  informative: 'Informativo',
}

export const alertColors = {
  notification: '#000',
  outbreak: '#5f27cd',
  urgent: '#005c0b',
  rise: '#27ae60',
  above: '#7bed9f',
  emergent: '#0dc022',
  below: '#fd5542',
  drop: '#c42210',
  informative: theme.colors.primary,
}

export type TimeSeriesDataProps = {
  key: string
  title: string
  label: string
  alertLevel: AlertLevel
}

export const timeSeriesInfo = {
  legalEntityAttendanceAppSebrae: {
    label: 'Atendimentos',
    title: 'SEBRAE Na Sua Empresa (App)',
    order: 1,
  },
  legalEntityAttendanceEad: {
    label: 'Atendimentos',
    title: 'Todos os cursos - EAD',
    order: 2,
  },
  legalEntityEadPortfolio: {
    label: 'Atendimentos',
    title: 'Cursos do portfólio - EAD',
    order: 3,
  },
  legalEntityAttendanceRadarAli: {
    label: 'Atendimentos',
    title: 'Radar ALI',
    order: 4,
  },
  legalEntityOpeningDate: {
    label: 'Novos CNPJs',
    title: 'Abertura de empresas',
    order: 5,
  },
  legalEntityClosingDate: {
    label: 'CNPJs fechados',
    title: 'Fechamento de empresas',
    order: 6,
  },
  legalEntityIndividualPortfolioCourses: {
    label: 'Atendimentos',
    title: 'Cursos individuais do portfólio',
    order: 7,
  },
} as const
